export default {
    emits: [
        'success',
        'closed'
    ],
    data () {
        return {
            tableData: [],
            total: 0,
            selection: [],
            visible: false,
            isSaveing: false,
            queryInfo: {
                page: 1,
                size: 10,
                keywords: "",
                goods_type: '2'
            },
            isLoading: false
        };
    },
    mounted () {
        this.getDataList();
    },
    methods: {
        refreshSearch () {
            this.queryInfo = this.$options.data().queryInfo;
            this.getDataList();
        },
        upsearch () {
            this.queryInfo.page = 1;
            this.getDataList();
        },
        //显示
        open () {
            this.visible = true;
            return this;
        },
        //! 分页功能
        paginationChange (page) {
            this.queryInfo.page = page;
            this.getDataList();
        },
        //! 页码切换
        pageSizeChange (size) {
            this.queryInfo.size = size;
            this.getDataList();
        },
        selectionChange (val) {
            console.log('11dasjdjiaoij1jdasoidj1', val);
            this.selection = val;
        },
        submit () {
            console.log('this.$refs.table.getSelectionRows()', this.selection);
            // const buildData = this.$refs.table.getSelectionRows()?.map(item => {
            // 	return {
            // 		...item,
            // 		product_id:item.id,
            // 		spec_id:item.spec_id,
            // 		type:item.goods_type,//套餐类型：1-实体商品 2-服务 3-课程商品 4-优惠券
            // 		num: 1
            // 	}
            // })
            let { id, spec_id, goods_type } = this.selection;
            const buildData = {
                ...this.selection,
                product_id: id,
                spec_id: spec_id,
                type: goods_type,
                num: 1
            };
            this.isSaveing = true;
            this.$emit('success', buildData);
            this.visible = false;
            this.isSaveing = false;
        },
        async getDataList () {
            this.isLoading = true;
            let res = await this.$API.goods.goods.list.get(this.queryInfo);
            this.isLoading = false;
            if (res?.code === 1) {
                this.tableData = res.data.data;
                this.total = res?.data?.total || 0;
            }
        }
    }
};
